import React from 'react';

export default () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 88 88" version="1.1">
      <title>noun-error-7085729</title>
      <g
        id="Virtual-Session"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="3.1.3---Connection-failed"
          transform="translate(-450, -322)"
          fill="#FF0000"
          fillRule="nonzero">
          <g id="Video-" transform="translate(-4, 50)">
            <g id="Video-screen" transform="translate(61, 0)">
              <g id="Loading" transform="translate(312.5, 272)">
                <g id="noun-error-7085729" transform="translate(80.9413, 0)">
                  <path
                    d="M35.3316579,5.1836 C36.9175579,2.0078 40.1675579,0 43.7144579,0 C47.2652579,0 50.5113579,2.0078 52.1011579,5.1836 L86.4411579,73.8636 C87.8942579,76.7659 87.7419579,80.2191 86.0309979,82.9847 C84.3239979,85.7464 81.3082979,87.43 78.0582979,87.43 L9.37429789,87.43 C6.12429789,87.43 3.10869789,85.7464 1.40159789,82.9847 C-0.309302113,80.2191 -0.461702113,76.7659 0.987537887,73.8636 L35.3316579,5.1836 Z M40.9214579,7.9766 L6.58145789,76.6566 C6.09707789,77.62535 6.14786789,78.7777 6.71817789,79.6996 C7.28458789,80.61757 8.29237789,81.184 9.37437789,81.184 L78.0583779,81.184 C79.1403779,81.184 80.1481779,80.61759 80.7145779,79.6996 C81.2848879,78.77772 81.3356679,77.6254 80.8512979,76.6566 L46.5112979,7.9766 C45.9800479,6.918 44.9018979,6.25 43.7143979,6.25 C42.5307979,6.25 41.4487979,6.91797 40.9213979,7.9766 L40.9214579,7.9766 Z M40.2808379,25.0896 C40.2808379,23.363 41.6792379,21.9607 43.4019379,21.9607 C45.1285379,21.9607 46.5269379,23.363 46.5269379,25.0896 L46.5269379,53.2106 C46.5269379,54.9333 45.1285379,56.3356 43.4019379,56.3356 C41.6792379,56.3356 40.2808379,54.9333 40.2808379,53.2106 L40.2808379,25.0896 Z M43.5581379,62.5856 C47.0073379,62.5856 49.8081379,65.3864 49.8081379,68.8395 C49.8081379,72.2887 47.0073379,75.0856 43.5581379,75.0856 C40.1128379,75.0856 37.3120379,72.2887 37.3120379,68.8395 C37.3120379,65.3864 40.1128379,62.5856 43.5581379,62.5856 Z"
                    id="Shape"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
